import React from 'react';

export function insertInnerDividers(array, dividerJsx) {
  return insertDividers(array, dividerJsx, array.length - 1, 1);
}

export function insertOuterDividers(array, dividerJsx) {
  return insertDividers(array, dividerJsx, array.length, 0);
}

function insertDividers(array, dividerJsx, begin, end) {
  for (let i = begin; i >= end; --i) {
    array.splice(i, 0, React.cloneElement(dividerJsx, { key: `divider_${i}` }));
  }

  return array;
}



// WEBPACK FOOTER //
// ./src/core/dividerUtils.js